import { render } from "./CallAnalysisDetails.vue?vue&type=template&id=20c14ea3"
import script from "./CallAnalysisDetails.vue?vue&type=script&lang=js"
export * from "./CallAnalysisDetails.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__